import React from 'react';
import { observable, action, makeObservable } from 'mobx';
import { observer } from 'mobx-react'
import { Drawer, Fab, IconButton, Tooltip } from '@mui/material';
import { ArrowLeft, FilterListOff, FilterList, Search } from '@mui/icons-material';
import LayoutStore from '../../store/LayoutStore';
import IconeLimpar from '../../img/icones/IconeLimpar';
import FiltroImportacaoStore from '../../store/FiltroImportacaoStore';
import '../escaninho/css/Filtros.css'
import FiltroOrigem from '../escaninho/filtro/FiltroOrigem';
import FiltroOrgaoJudicante from '../escaninho/filtro/FiltroOrgaoJudicante';
import FiltroClasse from '../escaninho/filtro/FiltroClasse';

interface IPropsFiltrosImportacao {
}


class FiltrosImportacao extends React.Component {
    aberto = false;
    versaoFiltroClasse = 0;

    abrirFiltros = () => {
        this.limpar();
        this.aberto = true;
    };

    fecharFiltros = () => {
        this.aberto = false;
    };

    pesquisar = (close: boolean) => {
        FiltroImportacaoStore.procurar(true);
        if (close) {
            this.fecharFiltros();
        }
    }

    limpar = () => {
        FiltroImportacaoStore.limparFiltros();
        this.versaoFiltroClasse++;
    }

    constructor(props: IPropsFiltrosImportacao) {
        super(props);

        makeObservable(this, {
            aberto: observable,
            versaoFiltroClasse: observable,
            abrirFiltros: action,
            fecharFiltros: action,
            limpar: action
        });
    }

    render() {
        return (
            <div>
                <Tooltip title='Abrir filtros'>
                    <IconButton onClick={this.abrirFiltros}
                        color={FiltroImportacaoStore.filtroAplicado ? 'primary' : 'default'}
                    >
                        <FilterList />
                    </IconButton>
                </Tooltip>
                {FiltroImportacaoStore.filtroAplicado && <Tooltip title='Limpar filtros'>
                    <IconButton onClick={FiltroImportacaoStore.limparFiltros}
                        color={FiltroImportacaoStore.filtroAplicado ? 'primary' : 'default'}
                    >
                        <FilterListOff />
                    </IconButton>
                </Tooltip>}
                <Drawer open={this.aberto}
                    onClose={this.fecharFiltros}
                    variant={'persistent'}
                    slotProps={{
                        paper: {
                            style: {
                                minWidth: '30ch',
                                borderTopRightRadius: 50,
                                backgroundColor: LayoutStore.backgroundColorFiltros,
                                color: 'white',
                                boxShadow: 'none',
                                border: 'none'
                            }
                        }
                    }}
                >
                    <div
                        style={{
                            backgroundColor: LayoutStore.backgroundColorFiltros,
                            color: 'white'
                        }}
                    >
                        <span
                            style={{
                                alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-around',
                                width: '100%'
                            }}
                        >
                            <h2 className="labelHeaderFiltros">Filtros</h2>
                            <div className="botoesFiltros" style={{ gap: 5 }}>
                                <Fab
                                    color="primary"
                                    size="small"
                                    title="Filtrar"
                                    onClick={this.pesquisar.bind(this, true)}
                                >
                                    <Search />
                                </Fab>
                                <Fab
                                    color="primary"
                                    size="small"
                                    title="Limpar Filtros"
                                    onClick={this.limpar}
                                >
                                    <IconeLimpar fill="white" />
                                </Fab>
                                <Fab
                                    color="primary"
                                    size="small"
                                    title="Fechar"
                                    onClick={this.fecharFiltros}
                                >
                                    <ArrowLeft />
                                </Fab>
                            </div>
                        </span>
                    </div>
                    <div
                        className="divFlexColumn"
                        style={{
                            backgroundColor: LayoutStore.backgroundColorFiltros,
                            color: 'white',
                            overflowY: 'auto',
                            overflowX: 'hidden',
                            height: '100%'
                        }}
                    >
                        <div
                            className='gridConteudoFiltros filtrosImportacaoConteudo'
                            style={{ backgroundColor: LayoutStore.backgroundColorFiltros }}
                        >
                            <FiltroOrgaoJudicante importacao />
                            <FiltroOrigem importacao />
                            <FiltroClasse key={this.versaoFiltroClasse} importacao />
                        </div>
                    </div>
                </Drawer>
            </div>
        );
    }
}

export default observer(FiltrosImportacao);
